import { useState, useEffect } from "react";
import { api } from "./api";

export const DEFAULTS = {
  home: {
    hero_line_1: "Building Businesses.",
    hero_line_2: "Creating Possibilities.",
    hero_subtext:
      "Touson Ventures is a diversified Indian company focused on building practical, innovative and sustainable businesses for a changing world.",
    who_title: "Who We Are",
    who_text:
      "Touson Ventures (OPC) Private Limited is a diversified Indian business company headquartered in Pune, Maharashtra. We identify, build and support promising business opportunities across sectors — combining innovation, technology and disciplined execution to create practical, customer-focused enterprises built to last.",
    approach_items: [
      { title: "Identify Opportunities", text: "We study markets and emerging needs to find meaningful, underserved opportunities." },
      { title: "Understand Customers", text: "Every venture begins with a deep understanding of the people it serves." },
      { title: "Apply Technology", text: "We use technology intelligently — where it creates real, measurable value." },
      { title: "Build Sustainably", text: "We favour durable business models and responsible growth over short-term wins." },
    ],
    why_items: [
      { title: "Innovation", text: "We question convention and build for how the world is changing." },
      { title: "Customer Focus", text: "Real customer needs sit at the centre of every decision we make." },
      { title: "Adaptability", text: "We stay nimble, learning and adjusting as markets evolve." },
      { title: "Responsible Growth", "text": "We grow with discipline, integrity and respect for stakeholders." },
      { title: "Long-Term Value", text: "We build businesses designed to endure and compound value over time." },
    ],
    cta_title: "Let's build what's next.",
    cta_text: "For business enquiries, partnerships and collaborations, we would be glad to hear from you.",
  },
  about: {
    intro:
      "Touson Ventures (OPC) Private Limited is a diversified Indian business company based in Pune, Maharashtra. We exist to identify, build and support promising business opportunities across different sectors — creating practical, sustainable and customer-focused businesses by combining innovation, technology and strong execution.",
    vision: "To build meaningful, sustainable and innovative businesses that create long-term value.",
    mission:
      "To identify opportunities, solve real-world problems and develop customer-focused businesses using technology, innovation and disciplined execution.",
    values: [
      { title: "Innovation", text: "We embrace new ideas and better ways of solving problems." },
      { title: "Integrity", text: "We act honestly and transparently in everything we do." },
      { title: "Customer Focus", text: "We build around the people our businesses serve." },
      { title: "Continuous Improvement", text: "We keep learning, refining and raising our standards." },
      { title: "Responsible Growth", text: "We pursue growth that is sustainable and principled." },
      { title: "Long-Term Thinking", text: "We make decisions with the future in mind, not just the quarter." },
    ],
  },
  approach_page: {
    intro:
      "Our approach is simple in principle and disciplined in practice: find real problems, understand them deeply, and build businesses that solve them well.",
    steps: [
      { title: "Identifying meaningful opportunities", text: "We look for genuine gaps and unmet needs — not trends — across promising sectors." },
      { title: "Understanding customer needs", text: "We listen first. Deep customer understanding shapes every venture we build." },
      { title: "Solving real-world problems", text: "We focus on practical solutions that make a tangible difference." },
      { title: "Using technology intelligently", text: "Technology is a tool — applied where it creates efficiency, reach and better experiences." },
      { title: "Building sustainable business models", text: "We design ventures with sound economics, built to last beyond the launch." },
      { title: "Maintaining high standards of execution", text: "Ideas matter less than delivery. We hold ourselves to disciplined execution." },
      { title: "Continuous improvement", text: "We measure, learn and refine — treating every venture as a work in progress." },
      { title: "Long-term value creation", text: "We optimise for enduring value for customers, partners and stakeholders." },
    ],
  },
  businesses_page: {
    intro:
      "Touson Ventures builds and supports businesses across promising sectors. Our portfolio is growing — new ventures are announced here as they launch.",
    explore_text:
      "We are always exploring and evaluating new opportunities across sectors where innovation, technology and strong execution can create meaningful, customer-focused businesses.",
  },
  contact: {
    intro:
      "Whether you are a customer, a potential partner, a vendor or simply curious about what we are building — we would be glad to hear from you.",
    email: "support@touson.in",
    address_lines: [
      "OFF.204, Sapphire Chambers",
      "S.No. 2/3/1 & 2/3/2, Riviresa",
      "Baner Gaon, Pune, Haveli",
      "Maharashtra, India – 411045",
    ],
  },
};

export function useContent() {
  const [content, setContent] = useState(DEFAULTS);
  useEffect(() => {
    api
      .get("/content")
      .then((r) => setContent({ ...DEFAULTS, ...r.data }))
      .catch(() => {});
  }, []);
  return content;
}

export function useBusinesses() {
  const [businesses, setBusinesses] = useState([]);
  useEffect(() => {
    api
      .get("/businesses")
      .then((r) => setBusinesses(r.data))
      .catch(() => {});
  }, []);
  return businesses;
}
